import styled from 'styled-components';

import COLOR from '../../../utils/colors.constants';

const ForgotPassword = styled.a`
  cursor: pointer;
  margin-top: 4px;
  margin-left: auto;
  color: ${COLOR.AZUL};
`;

export default ForgotPassword;
